import FooterContainer from './FooterContainer';
import FooterService from "./services/FooterSevice";
import stores from './stores';

const Footer = {
  path: ['/footer'],
  exact: true,
  services: [new FooterService()],
  stores: stores,
  component: FooterContainer,
};

export default Footer;
